"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDepositAction = void 0;
var react_1 = require("react");
var hooks_1 = require("../../shared/hooks");
var utils_1 = require("../../shared/utils");
function useDepositAction(_a) {
    var contract = _a.contract, decimals = _a.decimals, refresh = _a.refresh, gasPrice = _a.gasPrice, _b = _a.messages, messages = _b === void 0 ? { success: 'Successfully deposited', error: 'Deposit failed' } : _b;
    var account = (0, hooks_1.useUser)().account;
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    function deposit(depositValue) {
        var v = (0, utils_1.denormalizeDecimals)((0, utils_1.toWeiBN)(depositValue), decimals);
        if (v.eqn(0)) {
            return Promise.reject();
        }
        setIsLoading(true);
        return contract.methods
            .deposit(v)
            .send({ from: account, gasPrice: gasPrice })
            .then(function () { return ({ success: true, msg: messages.success }); })
            .catch(function (e) { return ({
            success: false,
            msg: messages.error,
            data: { message: e.message },
        }); })
            .finally(function () {
            setIsLoading(false);
            refresh();
        });
    }
    return { deposit: deposit, isLoading: isLoading };
}
exports.useDepositAction = useDepositAction;
